import React from 'react'
import AccordionSection from '../../../common/AccordionSection'
import { Deductible, CoInsurance } from '../../aobPayments/components/pricingEstimate/insuranceItems'
import { formatMoney } from '../../../utils/money'

interface InsurancePaysProps {
  totalInsPayment: number;
  payer1Name?: string;
  payer2Name?: string;
  payer3Name?: string;
  deductible?: number;
  deductibleRemaining?: number;
  coinsurancePercentage?: number;
}

export default function InsurancePayBlock({
  totalInsPayment,
  payer1Name,
  payer2Name,
  payer3Name,
  deductible,
  deductibleRemaining,
  coinsurancePercentage
}: InsurancePaysProps ) {
  return (
    <AccordionSection
      title="Insurance Pays:"
      amount={formatMoney( totalInsPayment )}
      toggleOpenText="Show Details"
      toggleCloseText="Hide Details"
    >
      <div className="inline-block float-left w-full text-graphite text-left">
        <p className="font-semibold pb-4 block">
          {`Your Health Insurance Information`}
        </p>
        {payer1Name && <p>{`Insurer #1: `}{payer1Name}</p>}
        {payer2Name && <p>{`Insurer #2: `}{payer2Name}</p>}
        {payer3Name && <p className="mb-5">{`Insurer #3: `}{payer3Name}</p>}
        <Deductible
          deductible={deductible}
          deductibleRemaining={deductibleRemaining}
        />
        <CoInsurance coIns={coinsurancePercentage} />
      </div>
    </AccordionSection>
  )
}
